<modal #modal>
    <div class="modal-header">
        <h5 class="modal-title">
            Betalingen kunne ikke gennemføres
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="close()">
            
        </button>
    </div>
    <div class="modal-body">
        <p>Din betaling er desværre ikke gået igennem til os. Det kan der være flere forskellige årsager til, prøv igen.</p>
        <button type="button" class="btn btn-green" aria-label="Close" (click)="close()">
            Ok
        </button>
        <p>Oplever du problemer, så kontakt Kundeservice via vores chat, <a href="mailto:kundeservice@klasselotteriet.dk">e-mail</a> eller telefon: 3342 0900</p>
    </div>
    <div class="modal-footer">
        <app-opening-hours></app-opening-hours>
    </div>
</modal>
